import { removeNonDigits } from '@accountFederation/utils';

export class Cpf {
    public readonly value: string;

    private constructor(cpf: string) {
        this.value = cpf;
    }

    public static parse(cpf: string) {
        const normalizedCpf = removeNonDigits(cpf);
        if (
            normalizedCpf?.length !== 11
            || normalizedCpf.match(/^(\d)\1{10}$/)
            || !Cpf.isControlNumberValid(normalizedCpf)
        ) { // Check it's not repeated same digit and has right length
            return null;
        }

        return new Cpf(normalizedCpf);
    }

    public static format(cpfNumber: string) {
        if (!Cpf.parse(cpfNumber)) {
            return undefined;
        }
        return cpfNumber.substring(0, 3) + '.' + cpfNumber.substring(3, 6) + '.' + cpfNumber.substring(6, 9) + '-' + cpfNumber.substring(9, 11);
    }

    private static isControlNumberValid(cpf: string): boolean {
        return this.calculateControlDigit(cpf, 1) === parseInt(cpf.charAt(9))
             && this.calculateControlDigit(cpf, 2) === parseInt(cpf.charAt(10));
    }

    private static getSumOfWeight(cpf: string, digitsCount: number, weight: number): number {
        let sum = 0;
        for (let i = 0; i < digitsCount; i++) {
            sum += parseInt(cpf.charAt(i)) * (weight - i);
        }
        return sum;
    }

    private static calculateControlDigit(cpf: string, number: 1 | 2) : number {
        const weight = number === 1 ? 10 : 11; // weight 10 for 1st digit, 11 for 2nd
        const digitsNum = number === 1 ? 9 : 10; // 9 digits sum for 1st digit, 10 digits sum for 2nd

        const sum = Cpf.getSumOfWeight(cpf, digitsNum, weight);
        const rest = sum % 11;
        return (rest < 2) ? 0 : (11 - rest);
    }
}
